import styles from './RatingMeter.module.css';
import { clampRating } from '../utils/investmentCase';

type Props = {
  value: number;
  /** Accessible label, e.g. "Founder ambition 4 of 6" */
  label: string;
};

/** Six segments; the first `value` (1–6) segments are highlighted. */
export function RatingMeter({ value, label }: Props) {
  const v = clampRating(value);
  return (
    <div
      className={styles.meter}
      role="img"
      aria-label={label}
      title={`${label}: ${v}/6`}
    >
      {Array.from({ length: 6 }, (_, i) => (
        <span key={i} className={i < v ? styles.barActive : styles.bar} />
      ))}
    </div>
  );
}
